import React from 'react';
import List from './list';
import Pagination from '../pagination';
import styles from './table.module.scss';

const Table = (props) => {
  const { count, page, limit, onPageChange, onLimitChange, limitOptions } = props;
  return (
    <div className={styles.tableWrapper}>
      <section className={styles.table}>
        <div className={styles.tableScroll}>
          <List {...props} />
        </div>
      {Number(page) >= 0 && Number(limit) > 0 && Number(count) >= 0 ? (
        <Pagination
          page={page}
          limit={limit}
          count={count}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          limitOptions={limitOptions}
        />
      ) : null}
      </section>
    </div>
  );
};

export default Table;
